module.exports = __webpack_public_path__ + "img/decoration-bottom.aa434262.svg";